import React, { useEffect, useState } from "react";
import { Box, Button, Container, Divider, Paper, Stack, Typography } from "@mui/material";
import { useHistory } from "react-router-dom";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import SearchOffRoundedIcon from "@mui/icons-material/SearchOffRounded";

const REDIRECT_SECONDS = 5;

const PageNotFound = () => {
  const history = useHistory();
  const [countdown, setCountdown] = useState(REDIRECT_SECONDS);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setCountdown((prev) => (prev > 1 ? prev - 1 : 0));
    }, 1000);

    const redirectTimer = window.setTimeout(() => {
      history.replace("/");
    }, REDIRECT_SECONDS * 1000);

    return () => {
      window.clearInterval(timer);
      window.clearTimeout(redirectTimer);
    };
  }, [history]);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        py: { xs: 4, md: 6 },
        background:
          "radial-gradient(circle at 18% 12%, rgba(25,118,210,0.12), transparent 28%), radial-gradient(circle at 82% 18%, rgba(5,105,13,0.10), transparent 26%), linear-gradient(180deg, #f8fafd 0%, #eef3f7 100%)",
      }}
    >
      <Container maxWidth="sm">
        <Paper
          variant="outlined"
          sx={{
            borderRadius: 3,
            p: { xs: 2.5, sm: 3.5 },
            overflow: "hidden",
            position: "relative",
            boxShadow: "0 16px 46px rgba(60,64,67,0.10)",
            "&:before": {
              content: '""',
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              height: 5,
              background: "linear-gradient(90deg, #05690D, #1976D2)",
            },
          }}
        >
          <Stack spacing={2.25} alignItems="center" textAlign="center">
            <Box
              sx={{
                width: 64,
                height: 64,
                borderRadius: 2.5,
                display: "grid",
                placeItems: "center",
                bgcolor: "rgba(25, 118, 210, 0.10)",
                color: "primary.main",
                border: "1px solid rgba(25, 118, 210, 0.18)",
              }}
            >
              <SearchOffRoundedIcon sx={{ fontSize: 34 }} />
            </Box>

            <Stack spacing={0.75}>
              <Typography variant="overline" sx={{ color: "primary.main", fontWeight: 850, letterSpacing: 1 }}>
                Error 404
              </Typography>
              <Typography
                variant="h4"
                sx={{
                  fontWeight: 850,
                  color: "#30343b",
                  letterSpacing: "-0.03em",
                  fontSize: { xs: "1.85rem", sm: "2.25rem" },
                }}
              >
                We could not find that page
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 430, lineHeight: 1.65 }}>
                The link may be outdated, mistyped, or no longer available in this workspace.
              </Typography>
            </Stack>

            <Divider flexItem />

            <Stack spacing={2} alignItems="center">
              <Typography variant="body2" color="text.secondary">
                Redirecting to home in <strong>{countdown}s</strong>.
              </Typography>
              <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5} justifyContent="center">
                <Button
                  variant="contained"
                  startIcon={<HomeRoundedIcon />}
                  onClick={() => history.replace("/")}
                  sx={{ textTransform: "none", fontWeight: 800, borderRadius: 2, px: 2.5 }}
                >
                  Go home
                </Button>
                <Button
                  variant="outlined"
                  startIcon={<ArrowBackRoundedIcon />}
                  onClick={() => history.goBack()}
                  sx={{ textTransform: "none", fontWeight: 800, borderRadius: 2, px: 2.5 }}
                >
                  Go back
                </Button>
              </Stack>
            </Stack>
          </Stack>
        </Paper>
      </Container>
    </Box>
  );
};

export default PageNotFound;
